import { Button } from "antd";
import { useInitializeDay } from "../hooks/useInitializeDay";

type InitDayBtnProps = {
  reloadData: () => void;
};

export const InitDayBtn = ({ reloadData }: InitDayBtnProps) => {
  const { isLoading, onInitializeDayClick } = useInitializeDay(reloadData);

  return (
    <Button
      shape="round"
      onClick={onInitializeDayClick}
      disabled={isLoading}
      className="ml-4"
    >
      Initialize Day
    </Button>
  );
};
